module.exports = __webpack_public_path__ + "static/img/workSite12.0c3d8d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/workSite12.png
// module id = fIig
// module chunks = 1